'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PopupContainer extends Component {
  render () {
    const items = this.props.items;
    const ItemElement = this.props.itemElement;

    return (
      <div className='maps-popup-container'>
        <div className='container-body'>
          {
            items.length
            ? items.map((item, idx) => <ItemElement key={idx} {...item} />)
            : 'не удалось загрузить данные'
          }
        </div>
      </div>
    );
  }
}

PopupContainer.propTypes = {
  items: PropTypes.array,
  itemElement: PropTypes.func.isRequired
};

PopupContainer.defaultProps = {
  item: []
};

export default PopupContainer;



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/Popup/PopupContainer.jsx